function sanitizeUniqueSorted(pages: number[]): number[] {
  const seen = new Set<number>();
  const out: number[] = [];
  for (const p of pages) {
    if (!Number.isFinite(p) || p < 1) continue;
    const n = Math.floor(p);
    if (seen.has(n)) continue;
    seen.add(n);
    out.push(n);
  }
  return out.sort((a, b) => a - b);
}

export function getVisiblePaginationPages(
  currentPage: number,
  totalPages: number
): number[] {
  if (!Number.isFinite(totalPages) || totalPages < 1) return [];

  const lastPage = Math.floor(totalPages);
  const current = Math.min(
    Math.max(1, Math.floor(Number.isFinite(currentPage) ? currentPage : 1)),
    lastPage
  );

  const pagesNumberArray: number[] = [];
  for (let i = 1; i <= lastPage; i += 1) {
    pagesNumberArray.push(i);
  }

  if (pagesNumberArray.length > 5 && current < 5) {
    pagesNumberArray.length = 5;
    return [...pagesNumberArray];
  }

  if (
    pagesNumberArray.length > 5 &&
    current >= 5 &&
    current < pagesNumberArray.length - 3
  ) {
    return sanitizeUniqueSorted([
      pagesNumberArray[current - 4],
      pagesNumberArray[current - 3],
      pagesNumberArray[current - 2],
      pagesNumberArray[current - 1],
      pagesNumberArray[current],
      pagesNumberArray[current + 1],
      pagesNumberArray[current + 2],
    ]);
  }

  if (pagesNumberArray.length > 5 && current >= pagesNumberArray.length - 4) {
    return [
      pagesNumberArray[pagesNumberArray.length - 5],
      pagesNumberArray[pagesNumberArray.length - 4],
      pagesNumberArray[pagesNumberArray.length - 3],
      pagesNumberArray[pagesNumberArray.length - 2],
      pagesNumberArray[pagesNumberArray.length - 1],
    ];
  }

  return pagesNumberArray;
}
